export const eventlist = (state) => state.eventlist
export const search = (state) => state.search
export const total = (state) => state.total
export const date_range = (state) => state.date_range
export const loading = (state) => state.loading
export const page = (state) => state.page
export const month_events = (state) => state.month_events
export const categorylist = (state) => state.categorylist
export const filter = (state) => state.filter
export const currentFilters = (state) => state.filter
export const isDateManuallySelected = (state) => state.isDateManuallySelected;
export const navigationDirection = (state) => state.navigationDirection;
